import {enableProdMode} from '@angular/core';
import {Environment} from "../app/types/environment";

enableProdMode();

export const prepareApp = async () => await Promise.resolve();

export const environment: Environment = {
    authenticationConfiguration: {
        authenticationWellKnownUrl: '',
        clientId: ''
    },
};
